import api from '@/api'
import store from '@/store'

import UserInfo from './UserInfo'
import { identifyForMonitoring } from './monitoring'

const context = {
  userAgent: window.navigator && window.navigator.userAgent
}

export function getUserInfo (): UserInfo | undefined {
  const { authenticatedUser } = store.state.user

  if (!authenticatedUser) {
    return undefined
  }

  const { workspace, accountId } = store.state.workspace

  return {
    userId: authenticatedUser.uid,
    email: authenticatedUser.email,
    firstName: authenticatedUser.firstName,
    lastName: authenticatedUser.lastName,
    isAdmin: authenticatedUser.admin || false,
    workspaceName: workspace.name,
    workspaceId: workspace.id,
    workspaceType: workspace.payload && workspace.payload.type,
    orgId: workspace.payload && workspace.payload.organization.id,
    accountId: accountId || undefined,
    groupId: accountId || undefined
  }
}

// For now, don't send any analytics events to the API if the user is not authenticated.
// In the future, we'll want to use an anonymous ID cookie to track events for
// unauthenticated users so we can access these events once they eventually use the
// platform.
const ClientAnalyticsProvider = {
  identify () {
    const userInfo = getUserInfo()
    if (!userInfo) {
      return
    }

    identifyForMonitoring(userInfo)
    api.createAnalyticsMessage({
      context,
      identifyPayload: {
        traits: userInfo
      }
    })
  },
  track (event: string, properties?: object) {
    const userInfo = getUserInfo()
    if (!userInfo) {
      return
    }

    api.createAnalyticsMessage({
      context,
      trackPayload: {
        event,
        properties: { ...userInfo, ...properties }
      }
    })
  },
  page (name: string, category?: string, properties?: object) {
    const userInfo = getUserInfo()
    if (!userInfo) {
      return
    }

    api.createAnalyticsMessage({
      context,
      pagePayload: {
        name,
        category,
        properties: { ...userInfo, ...properties }
      }
    })
  },
  group (accountId: string) {
    const userInfo = getUserInfo()
    if (!userInfo) return
    // Don't track groups for admins right now since they can switch between
    // accounts and will be hard to filter out
    if (userInfo.isAdmin) return

    api.createAnalyticsMessage({
      context,
      groupPayload: {
        accountId
      }
    })
  }
}

export default ClientAnalyticsProvider
